import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { socket } from 'api';
import { ConfirmComment } from '../confirm-comment/confirm-comment';
import { RadioPopup } from '../radio-popup/radio-popup';
import { Help } from '../help/help';
import { BlackButton } from '../oval-button/oval-button';
import { helpItems, modes, modesButtons } from './mode-selector.consts';
import { Content, Explanation, CurrentMode, Title } from './mode-selector.styled';

// type = rack | app

let tmpMode = '';

export const ModeSelector = (props) => {
  const { id, type = 'rack', sendControlMsg } = props;
  const mode = useSelector((store) => (store.equipment[id] ? store.equipment[id].mode : ''));
  const { t } = useTranslation();
  const [popup, setPopup] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const rightControl = window.haveRight('mnemo.rack_control');
  const withComment = window.dict['reasonofpass'] !== undefined;
  const cl = mode === 'emergency' ? 'error' : '';
  const error = type === 'app' && mode === 'emergency';

  // clear loading
  useEffect(() => {
    const stopLoading = () => {
      setLoading(false);
    };

    socket.on('get_state', stopLoading);

    return () => {
      socket.off('get_state', stopLoading);
    };
  }, []);

  if (mode === undefined) {
    return null;
  }

  /**
   * set new mode
   * @param {*} comment?
   */
  const submitNewMode = (newMode, comment = '') => {
    setLoading(true);
    const out = {
      mode: newMode,
    };
    if (comment) {
      out.comment = comment;
    }
    sendControlMsg('set_mode', null, out);
  };

  /**
   * set rack mode with cofirm and comment
   */
  const setMode = (newMode) => {
    // app
    if (type === 'app') {
      submitNewMode(newMode);
      return;
    }

    // rack
    // console.log("🚀 ~ setMode ~ withComment || mode:", withComment,  mode)
    if (!withComment || newMode !== 'free') {
      submitNewMode(newMode);
      togglePopup();
      return;
    }

    // confirm
    tmpMode = newMode;
    togglePopup();
    setConfirm(true);
  };

  /**
   * set rack mode after confirm
   */
  const setModeAfterConfirm = (comment) => {
    closeConfirm();
    submitNewMode(tmpMode, comment);
    // togglePopup();
  };

  /**
   * toggle mode popup
   */
  const togglePopup = () => {
    setPopup((val) => !val);
  };

  /**
   * get mode title
   * @returns
   */
  const getModeTitle = (mode) => {
    // console.log('mode', mode);
    return modes[type][mode] ?? '';
  };

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(false);
  };

  // consts
  const helpItemsOk = helpItems[type].map((el) => {
    const out = { ...el };
    out.title = t('clarifications.' + out.title);
    out.info = t('clarifications.' + out.info);
    return out;
  });
  const modeTitle = getModeTitle(mode);
  // console.log(modeTitle)
  const items = modesButtons[type].map((el) => {
    return { name: t('clarifications.' + getModeTitle(el)), value: el };
  });

  return (
    <>
      <Content>
        {type === 'rack' ? (
          <BlackButton disabled={!rightControl} onClick={togglePopup} className="mr10">
            {t('buttons.Режим работы')}
          </BlackButton>
        ) : (
          <Title className="mr10">{t('windows.Режимы работы')}</Title>
        )}

        {type === 'rack' && popup && <RadioPopup value={mode} submit={setMode} close={togglePopup} buttons={items} disabled={!rightControl} />}

        <Help items={helpItemsOk} />

        <CurrentMode className={cl}>
          {t('windows.Текущий режим')}: <span>{t('clarifications.' + modeTitle)}</span>
          {error && <Explanation>{t('messages.оборудования АПП')}</Explanation>}
        </CurrentMode>
        {confirm && <ConfirmComment close={closeConfirm} action={setModeAfterConfirm} />}
      </Content>
      {type === 'app' && <RadioPopup simple={true} value={mode} submit={setMode} close={togglePopup} buttons={items} disabled={!rightControl} />}
    </>
  );
};
